import {Skeleton } from "antd";
import EmptyList from "~/components/app/EmptyList";

const SkeletonList = ({ data, children }) => {
  const loading = !data;
  const hasData = data && data.length > 0;

  return (
    <Skeleton loading={loading}>
      <EmptyList hasData={hasData}>
        {children}
      </EmptyList>
    </Skeleton>
  );
};

export default SkeletonList;
